import { BaseService } from "@/core/services/BaseService";
import { ENDPOINT } from "@/core/config/Constant";
import { IProduct } from "@/core/entity/IProduct";

class ProductService extends BaseService<IProduct> {
  endpoint = ENDPOINT.PRODUCT
}
export default new ProductService();